import styles from "./FJResourcesElementSearch.module.less";
import InlineSVG from "react-inlinesvg";
import searchSvg from "../../../icon/search.svg";
import closeSvg from "../../../icon/small_close.svg";
import React from "react";

function FJElementSearchInput(props) {

  let {
    style,
    onChangeInput,
    inputOnKeyUp,
    inputRef,
    onClickClearInputValue,
    searchValue,
    onBlur,
    onFocus,
		placeholder
  } = props

  return (
    <div className={styles.search_input_button}>
      <InlineSVG src={searchSvg} className={styles.search_icon}/>
      <div className={styles.close_icon} style={style} onClick={onClickClearInputValue}>
        <InlineSVG src={closeSvg}/>
      </div>
      <input className={styles.search_input}
             type="text"
             ref={inputRef}
             placeholder={placeholder}
             onKeyUp={inputOnKeyUp}
             onChange={onChangeInput}
             value={searchValue}
             onBlur={onBlur}
             onFocus={onFocus}
      />
    </div>
  )
}

export default FJElementSearchInput;